import React from "react";
import AdmTraining from "../../components/AdminTabs/AdminTrainingAndPlacement/AdmTraining";

const Training = () => {
  return (
    <div>
      <AdmTraining/>
    </div>
  );
};

export default Training;
